import React from 'react';

const AaCoreAiName: React.FC<{
  color?: string;
  aiColor?: string;
  className?: string;
  ask?: boolean;
  showIcon?: boolean;
  iconClassName?: string;
}> = ({ color, aiColor, className, ask, showIcon = true, iconClassName }) => (
  <span
    className={`flex items-center gap-1.5 font-semibold ${className || 'text-xs'}`}
    style={color ? { color } : undefined}
  >
    {showIcon ? (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={`${iconClassName || 'w-3.5 h-3.5'} flex-shrink-0`}>
        <path fill="currentColor" d="M12 2.5 13.4 7 18 8.4 13.4 9.8 12 14.4 10.6 9.8 6 8.4 10.6 7z" />
        <path fill="currentColor" d="M18.2 13.2 19 15.6 21.4 16.4 19 17.2 18.2 19.6 17.4 17.2 15 16.4 17.4 15.6z" />
      </svg>
    ) : null}
    <span>
      {ask ? 'Ask ' : ''}AACore{' '}
      <small
        style={{
          fontFamily: 'Outfit, Inter, system-ui, sans-serif',
          fontStyle: 'normal',
          fontSize: '0.61em',
          fontWeight: 650,
          letterSpacing: '0.02em',
          marginLeft: 3,
          color: aiColor || color,
        }}
      >
        AI
      </small>
    </span>
  </span>
);

export default AaCoreAiName;
